// src/api/profileAPI.js
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000';

// Fetch anime data for a specific status
export const fetchAnimeData = async (status) => {
  const token = localStorage.getItem('token');
  
  if (!token) {
    throw new Error('Authentication required');
  }
  
  try {
    // FIXED PATH: Use /user/anime/status instead of /anime/status
    const response = await axios.get(
      `${API_BASE_URL}/api/user/anime/status/${status}`, 
      {
        headers: { Authorization: `Bearer ${token}` }
      }
    );
    
    return response.data.data || [];
  } catch (error) {
    console.error(`Error fetching ${status} anime:`, error);
    return [];
  }
};

// Fetch manga data for a specific status
export const fetchMangaData = async (status) => {
  const token = localStorage.getItem('token');
  
  if (!token) {
    throw new Error('Authentication required');
  }
  
  try {
    // FIXED PATH: Use /user/manga/status instead of /manga/status
    const response = await axios.get(
      `${API_BASE_URL}/api/user/manga/status/${status}`, 
      {
        headers: { Authorization: `Bearer ${token}` }
      }
    );
    
    return response.data.data || [];
  } catch (error) {
    console.error(`Error fetching ${status} manga:`, error);
    return [];
  }
};

// Fetch favorite characters
export const fetchFavoriteCharacters = async () => {
  const token = localStorage.getItem('token');
  
  if (!token) {
    throw new Error('Authentication required');
  }
  
  try {
    // FIXED PATH: Use /user/characters/favorites instead of /characters/favorites
    const response = await axios.get(
      `${API_BASE_URL}/api/user/characters/favorites`, 
      {
        headers: { Authorization: `Bearer ${token}` }
      }
    );
    
    return response.data.data || [];
  } catch (error) {
    console.error('Error fetching favorite characters:', error);
    return [];
  }
};

// New unified fetch function (not used yet, but ready for future optimization)
export const fetchAllProfileData = async () => {
  const token = localStorage.getItem('token');
  
  if (!token) {
    throw new Error('Authentication required');
  }
  
  try {
    const response = await axios.get(
      `${API_BASE_URL}/api/profile/all`, 
      {
        headers: { Authorization: `Bearer ${token}` }
      }
    );
    
    if (!response.data.success) {
      throw new Error(response.data.error || 'Failed to fetch profile data');
    }
    
    return response.data.data || {
      anime: { watching: [], completed: [], planning: [], onHold: [], dropped: [] },
      manga: { reading: [], completed: [], planning: [], onHold: [], dropped: [] },
      characters: []
    };
  } catch (error) {
    console.error('Error fetching profile data:', error);
    // Return empty data structure on error
    return {
      anime: { watching: [], completed: [], planning: [], onHold: [], dropped: [] },
      manga: { reading: [], completed: [], planning: [], onHold: [], dropped: [] },
      characters: []
    };
  }
};